import React, { useState, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Alert,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import axios from "axios";

const UpdateAdminProfile = () => {
  const [formData, setFormData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  // ✅ Password strength validation function
  const isPasswordStrong = (password) => {
    return (
      password.length >= 8 &&
      /[A-Z]/.test(password) &&         // at least one uppercase
      /[a-z]/.test(password) &&         // at least one lowercase
      /[0-9]/.test(password) &&         // at least one number
      /[^A-Za-z0-9]/.test(password)     // at least one special character
    );
  };

  useEffect(() => {
    const token = localStorage.getItem("admin_token");

    if (!token) {
      setError("Admin token missing.");
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(`${API_BASE}/api/admin_bp/profile`, { headers })
      .then((res) => {
        const { password_hash, ...data } = res.data;
        setFormData({ ...data, password: "" }); // Clear password
      })
      .catch(() => setError("Failed to load profile."));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const token = localStorage.getItem("admin_token");

    if (formData.password && !isPasswordStrong(formData.password)) {
      setError("Password is too weak. Please meet all the password criteria.");
      return;
    }

    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const payload = { ...formData };
      if (!payload.password) delete payload.password;
      const API_BASE = process.env.REACT_APP_API_BASE_URL;


      await axios.put(`${API_BASE}/api/admin_bp/profile/update`, payload, { headers });
      setSuccess("Profile updated successfully.");
    } catch (err) {
      setError("Failed to update profile.");
      console.error("Update error:", err);
    }
  };

  return (
    <Container className="mt-5">
      <h3 className="text-center mb-4">Update Admin Profile</h3>

      <Card className="p-4 shadow rounded">
        {success && <Alert variant="success">{success}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Leave blank to keep current password"
                className="me-2"
                isInvalid={formData.password && !isPasswordStrong(formData.password)}
              />
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "Hide" : "Show"}
              </Button>
            </div>
           
            {formData.password && !isPasswordStrong(formData.password) && (
              <Form.Text className="text-danger d-block">
                Password must be at least 8 characters, and include an uppercase letter, lowercase letter, number, and special character.
              </Form.Text>
            )}
          </Form.Group>

          <div className="text-center">
            <Button type="submit" variant="primary">
              Update Profile
            </Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
};

export default UpdateAdminProfile;
